import { GetterTree } from 'vuex';
import { State } from './browserCommon.store';

const getters: GetterTree<State, State> = {
  getAllBrowserServices: state => {
    return state.browserServices;
  },
  getVersions: state => {
    return state.versions;
  },
  getPages: state => {
    return state.browserPages;
  },
  getCurrentBrowserService: state => {
    return state.currentBrowserService;
  },
  getCurrentVersion: state => {
    return state.currentBrowserVersion;
  },
  getCurrentBrowserPage: state => {
    return state.currentBrowserPage;
  }
};
export default getters;
